import React from "react";
import { ChevronDown } from "@sonder/ui/source/icons";
import { Dropdown } from "@sonder/ui/source/styled/components/Dropdown";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { CheckboxDropdownItem } from "@sonder/ui/source/styled/fragments/CheckboxDropdownItem";
import {
  FilterButtonList,
  FilterDropdownContent,
  FilterFooter,
} from "@sonder/ui/source/styled/fragments/GenericFilters";
import { Link } from "@sonder/ui/source/styled/fragments/Link";
import { setFilters, unsetFilters } from "schedule/actions";
import { initialState } from "schedule/reducer";
import { useStore } from "schedule/store";
import { FilterPair, areStatusFiltersActive } from "tasks/helpers";
import { useSegmentQueue } from "tasks/hooks";
import { FilterStatus, TaskFilterInput } from "typings/globalGQLTypes";

interface FilterGroupItemProps {
  label: string;
  segmentId: string;
  filters: TaskFilterInput;
  isActive?(props: FilterPair): boolean;
}

export const TaskStatusFiltersGroupItem = (props: FilterGroupItemProps) => {
  const { filters, isActive = () => false, label, segmentId } = props;
  const {
    state: { filters: globalFilters },
    dispatch,
  } = useStore();
  const pushToSegmentQueue = useSegmentQueue(globalFilters);
  const active = isActive({ globalFilters, localFilters: filters });
  return (
    <CheckboxDropdownItem
      checked={active}
      onClick={() => {
        if (active) dispatch(unsetFilters(filters));
        else dispatch(setFilters(filters));

        pushToSegmentQueue({
          eventName: "schedule_task_status_filters",
          action: "click",
          element: segmentId,
          props: { nextValue: !active ? "selected" : "deselected" },
          commonProps: {},
        });
      }}
    >
      {label}
    </CheckboxDropdownItem>
  );
};

export const TaskStatusFilters = () => {
  const {
    state: { filters: globalFilters },
    dispatch,
  } = useStore();

  const { status } = globalFilters;
  const totalSelected = (status && status.length) || 0;

  return (
    <Dropdown
      trigger={
        <Button fullWidth iconRight type="button">
          Status
          {totalSelected > 0 && ` (${totalSelected})`}
          <ChevronDown />
        </Button>
      }
    >
      {({ isOpen: isPortalOpen }) =>
        isPortalOpen && (
          <FilterDropdownContent align="left">
            <FilterButtonList>
              {/* Please Keep this in Sync with AdditionalFilters.tsx */}
              <TaskStatusFiltersGroupItem
                filters={{ status: [FilterStatus.complete] }}
                isActive={areStatusFiltersActive}
                label="Complete"
                segmentId="status_complete"
              />
              <TaskStatusFiltersGroupItem
                filters={{ status: [FilterStatus.incomplete] }}
                isActive={areStatusFiltersActive}
                label="Incomplete"
                segmentId="status_incomplete"
              />
              <TaskStatusFiltersGroupItem
                filters={{ status: [FilterStatus.inprogress] }}
                isActive={areStatusFiltersActive}
                label="In Progress"
                segmentId="status_inprogress"
              />
            </FilterButtonList>
            <FilterFooter>
              {`${totalSelected || 0} Selected`}
              {totalSelected > 0 && (
                <Link
                  onClick={() => {
                    requestAnimationFrame(() =>
                      dispatch(
                        unsetFilters({
                          status: initialState.filters.status,
                        }),
                      ),
                    );
                  }}
                >
                  Clear selected
                </Link>
              )}
            </FilterFooter>
          </FilterDropdownContent>
        )
      }
    </Dropdown>
  );
};
